import { Component, OnInit } from '@angular/core';
import { Attivazione } from '../../../models/attivazione';
import { AlgAttivazioniService } from '../../../services/alg-attivazioni.service';
@Component({
  selector: 'alg-attivazioni-steps',
  templateUrl: './alg-attivazioni-steps.component.html',
  styleUrls: ['./alg-attivazioni-steps.component.scss']
})
export class AlgAttivazioniStepsComponent implements OnInit {
  public attivazione: Attivazione;
  public steps = [{
    name: 'step1',
    title: '2/3 I tuoi documenti',
    icon: 'documents'
  }, {
    name: 'step2',
    title: '3/3 Riepilogo',
    icon: 'documents'
  }];

  constructor(private api: AlgAttivazioniService) {}

  ngOnInit() {
    this.api.attivazione$
    .subscribe((attivazione) => {
        if (!attivazione) {
            return;
        }
        this.attivazione = attivazione;
    });
  };

};





// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-steps/alg-attivazioni-steps.component.ts